import { render } from "./CheckoutCancel.vue?vue&type=template&id=4b128bbc"
import script from "./CheckoutCancel.vue?vue&type=script&lang=js"
export * from "./CheckoutCancel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__